<template>
  <div class="card text-left border-0 shadow usage-by-entitie-container-size">
      <div class="card-header text-start">
          <h5><b>USAGE BY ENTITIES</b></h5>
      </div>
      <table class="table table-borderless align-middle">
        <tr :class="[keys !== lastKey? 'border-bottom': '']" v-for="(values, keys) in usageByEntities">
          <td><h6 class="card-title text-start">{{ keys }}</h6></td>
          <td v-if="values.total !== 0" @click="showModal(values.campaignIdList)" data-bs-toggle="modal" data-bs-target="#entityModal">
          <p class="mb-1 entity-item p-1 text-start"><b>{{ values.total }}</b>  Man-Days</p>
          </td>
        </tr>
      </table>
  </div>

  <div class="modal fade" id="entityModal" tabindex="-1" role="dialog" aria-labelledby="entityModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Entity Product information</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <div class="modal-body" v-if="productCroDate">
          <li v-for="item in productCroDate" :key="item" style="list-style: none;">
            {{dateParse(item)}}
          </li>
        </div>
        <div class="table-responsive" v-if="entityProductCampaignsId">
          <table class="table table-borderless table-hover align-middle">
            <thead>
              <tr>
                <th scope="col" class="ps-5">Campaigns ID</th>
                <th scope="col" class="ps-5">Usage</th>
                <th scope="col" class="ps-5">Time Spent</th>
                <th scope="col" class="pe-5">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in entityProductCampaignsId" class="p-2" :key="key">
                <td class="ps-5" scope="row" v-if="value.usage > 0">
                  <a v-bind:href="'https://app2.abtasty.com/edit/test/'+key+'/main-information'" class="" id:=index dtarget="_blank">
                    {{ key }}
                  </a>
                 </td>
                <td class="ps-5" v-if="value.usage > 0 && value.usage > 1">{{ value.usage }} days </td>
                <td class="ps-5" v-if="value.usage > 0 && value.usage <= 1">{{ value.usage }} day </td>
                <td class="ps-5" v-if='value.usage >0'>{{ value.timeSpentOnCampaign }} FTE</td>
                <td class="pe-5" v-if="value.usage > 0">{{ value.latestDescription }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

let props = defineProps({
  usageByEntities: Object,
  lastKey: String
})
</script>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UsageByEntities',
  props: ['usageByEntities', 'detailsURL'],
  data () {
    return {
      entityProductCampaignsId: null,
      productCroDate: null
    }
  },
  methods: {
    showModal (item) {
      this.entityProductCampaignsId = item
    }
  },
  computed: {
    dateParse (date) {
      return dayjs(date).format('DD-MM-YYYY')
    }
  }
})
</script>

<style scoped>
.entity-item:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}

.usage-by-entitie-container-size {
  width: 100%;
  margin-top: 2vh;
  position: relative;
}


</style>
